import React, { Component, Fragment } from 'react';
import { withStyles } from '@material-ui/core/styles';
import TableCell from "@material-ui/core/TableCell";
import TableHead from "@material-ui/core/TableHead";
import TableRow from "@material-ui/core/TableRow";
import { connect } from 'react-redux';
import * as actions from '../../store/actions/index';
import PropTypes from 'prop-types';

const styles = theme => ({
    root: {
        width: '100vw',
        // height: '100vh', /* Magic here */
        //marginLeft:'28%'

        //margin: '0 auto',
    },
    uploadDocs:{
        marginTop:'20px'
        //margin: '0 auto',
    },
    formControl: {
        margin: theme.spacing.unit * 3,
    },
    group:{
    },
    radio: {
        '&$checked' : {
            color: '#B71C1C',
        },
    },
    checked: {},
    progress: {
        /*display: 'flex',
        flexDirection: 'row',
        flexWrap: 'wrap',
        justifyContent: 'center',
        alignItem: 'center',*/
        flexDirection: 'column',
        margin: theme.spacing.unit * 3,
    },
    button:{
        display:'flex',
        //justifyContent: 'center',
        margin: '0 Auto',
    },
    margin : {
        marginTop:'40px',
        fontWeight: 'bold'
    },
    row:{
        border:'none',
        fontSize:'13px',
        fontWeight:'normal'
    }
});

class LoginRecords extends Component {
    state = {
      AddNoOfDays:0,
      typeOfAccount:localStorage.getItem('typeOfAccount'),
      uniqueId: localStorage.getItem('token')
    };

    componentWillMount(){

    }

    componentDidMount(){
        
    }

    render(){
        const { classes } = this.props;

        return(
            <div className={classes.root} style={{ marginTop:'30px', marginLeft: '20px' }} >

                {this.props.caseData.respondent_loginRecord !== undefined && 
                <TableRow>
                    <TableCell>
                        {this.context.t("Respondent Login Record")}
                    </TableCell>
                    {
                    this.props.caseData.respondent_loginRecord.map((record)=>
                        <TableCell>
                            {new Date(record).getDate()
                            +'-'+(new Date(record).getMonth()+1)
                            +'-'+new Date(record).getFullYear()
                            +' '+(''+new Date(record).getHours()).padStart(2, '0')
                            +':'+new Date(record).getMinutes()
                            +':'+(''+new Date(record).getSeconds()).padStart(2, '0')}
                        </TableCell>
                    )
                    }
                </TableRow>}

                {this.props.caseData.claimant_loginRecord !== undefined && 
                <TableRow>
                    <TableCell>
                        {this.context.t("Claimant Login Record")}
                    </TableCell>
                    { 
                    this.props.caseData.claimant_loginRecord.map((record) =>
                        <TableCell>
                            {new Date(record).getDate()
                            +'-'+(new Date(record).getMonth()+1)
                            +'-'+new Date(record).getFullYear()
                            +' '+(''+new Date(record).getHours()).padStart(2, '0')
                            +':'+new Date(record).getMinutes()
                            +':'+(''+new Date(record).getSeconds()).padStart(2, '0')}
                        </TableCell>
                    )
                    }
                    
                </TableRow>}
            </div>
        );
    }
}

const mapStateToProps = (state) => {
    return {
        isLoading: state.uploadDocs.loading,
        userType: state.caseInfo.userType,
        caseId: state.caseInfo.caseId,
        caseData: state.caseInfo.caseData,
    }
}

const mapDispatchToProps = (dispatch) => {
    return {

    }
}

LoginRecords.contextTypes = {
    t: PropTypes.func
  }

export default connect(mapStateToProps, mapDispatchToProps)(withStyles(styles)(LoginRecords));
